import {
  Sparkles,
  Home,
  Hash,
  Compass,
  Smartphone,
  ScrollText,
  Grid3x3,
  HeartPulse,
  Gem,
  Diamond,
  Feather,
  Shapes,
  Palette,
  CreditCard,
  PenLine,
} from "lucide-react";
import { hinglish } from "@/i18n/hinglish";

export const CONTACT = {
  phoneDisplay: "+91 95920 15559",
  phoneRaw: "+919592015559",
  whatsapp: "https://wa.me/919592015559",
  tel: "tel:+919592015559",
};

export const serviceIcons = [
  Sparkles, Home, Hash, Compass, Smartphone, ScrollText,
  Grid3x3, HeartPulse, Gem, Diamond, Feather, Shapes,
  Palette, CreditCard, PenLine,
];

// language-independent
export const serviceSlugs = [
  "jyotish",
  "vastu",
  "numerology",
  "karma-alignment",
  "mobile-numerology",
  "yantra-mantra",
  "runes",
  "healing",
  "crystal",
  "raashi-ratn",
  "mojo-bag",
  "zibu-symbol",
  "logo-design",
  "card-design",
  "signature-analysis",
];

export const serviceImages = [
  "https://images.unsplash.com/photo-1729335511883-29eade10006b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxhc3Ryb2xvZ3klMjB6b2RpYWMlMjB2ZWRpYyUyMGNoYXJ0fGVufDB8fHx8MTc4NjcxMTU0Nnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1502473379243-ba6449c3b6c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHx2YXN0dSUyMGhvdXNlJTIwY29tcGFzcyUyMGFyY2hpdGVjdHVyZSUyMGRpcmVjdGlvbnxlbnwwfHx8fDE3ODY3MTI4MDl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1484335629320-0e089b87a106?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxudW1iZXJzJTIwbnVtZXJvbG9neSUyMGRhcmslMjBteXN0aWNhbHxlbnwwfHx8fDE3ODY3MTI4MDl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1541795083-1b160cf4f3d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxpbmNlbnNlJTIwc21va2UlMjBtYXJpZ29sZCUyMGZsb3dlcnMlMjBkYXJrfGVufDB8fHx8MTc4NjcxMTU0Nnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1502570149819-b2260483d302?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxudW1iZXJzJTIwbnVtZXJvbG9neSUyMGRhcmslMjBteXN0aWNhbHxlbnwwfHx8fDE3ODY3MTI4MDl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1741003411334-e6a66b3b78f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB0ZW1wbGUlMjBvaWwlMjBsYW1wJTIwZGl5YSUyMHJpdHVhbHxlbnwwfHx8fDE3ODY3MTE1NDZ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1693517254723-f36fdd9265bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxydW5lJTIwc3RvbmVzJTIwZGl2aW5hdGlvbnxlbnwwfHx8fDE3ODY3MTI4MDl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1528319725582-ddc096101511?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxtZWRpdGF0aW9uJTIwZW5lcmd5JTIwaGVhbGluZyUyMGhhbmRzJTIwcmVpa2l8ZW58MHx8fHwxNzg2NzEyODA5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/4040611/pexels-photo-4040611.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1592317295760-5c1f677dfc78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxnZW1zdG9uZSUyMHJpbmclMjBwcmVjaW91cyUyMHN0b25lJTIwamV3ZWxyeXxlbnwwfHx8fDE3ODY3MTI4MDl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1566792720002-d52fdf3d050a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxoZXJicyUyMHBvdWNoJTIwZHJpZWQlMjBmbG93ZXJzJTIwcml0dWFsfGVufDB8fHx8MTc4NjcxMjgxN3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1711552466487-ac9afb5528cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxtYW5kYWxhJTIwcGF0dGVybiUyMGdvbGR8ZW58MHx8fHwxNzg2NzEyODE4fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1781615851882-1723fd059fad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxsb2dvJTIwYnJhbmQlMjBpZGVudGl0eSUyMGRlc2lnbiUyMHN0dWRpb3xlbnwwfHx8fDE3ODY3MTQ3NDJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1623305463957-df17547327cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGNhcmQlMjBzdGF0aW9uZXJ5JTIwbW9ja3VwJTIwbWluaW1hbHxlbnwwfHx8fDE3ODY3MTQ3NDJ8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1455390582262-044cdead277a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxzaWduYXR1cmUlMjBoYW5kd3JpdGluZyUyMGZvdW50YWluJTIwcGVufGVufDB8fHx8MTc4NjcxNDc0Mnww&ixlib=rb-4.1.0&q=85",
];

export const content = {
  en: {
    dir: "en",
    brand: "Nakshtra Vidhya",
    nav: {
      about: "About",
      philosophy: "Philosophy",
      services: "Services",
      contact: "Contact",
      call: "Call Now",
    },
    hero: {
      overline: "Vastu · Astrology · Ancient Vedic Sciences",
      titleLines: ["Guidance rooted", "in ancient", "vedic wisdom."],
      subtitle:
        "Nakshtra Vidhya helps you read the quiet signals of your home, your stars and your numbers — so you can move through life with clarity, not fear.",
      ctaPrimary: "Explore Services",
      ctaSecondary: "Talk on WhatsApp",
      badge: "15+ Years of Practice",
    },
    marquee: ["Vastu", "Jyotish", "Numerology", "Healing", "Yantra", "Mantra", "Crystal", "Karma"],
    philosophy: {
      overline: "The Philosophy",
      title: "To warn and protect —\nnever to frighten.",
      chapters: [
        { no: "01", title: "An ancient science, not superstition", body: "Vastu and Jyotish are among the oldest observational sciences of India — refined over thousands of years to understand how space, time and energy shape our lives." },
        { no: "02", title: "A gentle warning, in time", body: "The purpose is never to spread fear. It is to give you an early, caring signal — so that small corrections today can protect the years ahead." },
        { no: "03", title: "Clarity you can act on", body: "Every reading ends with simple, practical remedies — a direction to shift, a mantra to keep, a stone to wear — grounded, honest and doable." },
      ],
    },
    about: {
      overline: "About Nakshtra Vidhya",
      title: "Fifteen years of\nuncovering the hidden.",
      body: [
        "For over 15 years, Nakshtra Vidhya has guided families and individuals through the ancient sciences of Vastu, Jyotish and allied vedic practices.",
        "The approach here is calm, personal and free of fear-mongering — reading your chart, your home and your numbers, then translating them into remedies you can actually live with.",
        "People come here not for predictions of doom, but for reassurance, direction and a sense of protection over the things they love.",
      ],
      stats: [
        { value: "15+", label: "Years of practice" },
        { value: "15", label: "Vedic disciplines" },
        { value: "1000s", label: "Consultations given" },
      ],
    },
    services: {
      overline: "What Nakshtra Vidhya Offers",
      title: "Fifteen paths of\nvedic guidance.",
      subtitle: "Each service is a doorway — choose the one that speaks to what you are carrying right now.",
      cardCta: "Learn more",
      helpTitle: "Not sure where to begin?",
      helpCta: "Ask on WhatsApp",
      items: [
        {
          name: "Jyotish", tag: "Vedic Astrology", desc: "Reading your birth chart to understand timing, strengths and the road ahead.",
          highlights: ["Kundali in any language", "Free delivery across India", "In-depth Kundali analysis"],
          long: "Jyotish, the 'science of light', studies the position of the planets at your birth to reveal your natural strengths, karmic lessons and the timing of important life events. Nakshtra Vidhya prepares your Kundali (birth chart) in the language of your choice — with free delivery anywhere in India — then reads it with warmth, highlighting opportunities and gently flagging the periods that ask for care.",
          duration: "60–90 minutes",
          expect: ["A hand-prepared Kundali (birth chart) in the language you prefer", "Free delivery anywhere in India", "An in-depth, house-by-house Kundali analysis", "Honest insight into career, relationships, health and finances", "Simple, practical remedies to strengthen weak areas"],
          bring: ["Your exact date of birth", "Your accurate time of birth", "Your place of birth (city)"],
        },
        {
          name: "Vastu", tag: "Space Harmony", desc: "Aligning your home and workplace with natural energy for balance and growth.",
          highlights: ["Fixes without demolition", "Homes & commercial spaces"],
          long: "Vastu Shastra aligns your living and working spaces with the five elements and the flow of natural energy. For both homes and commercial spaces, Nakshtra Vidhya pinpoints where the energy supports you and where it quietly drains you — then prescribes practical corrections that almost never require demolition or breaking walls.",
          duration: "60–90 minutes",
          expect: ["A room-by-room reading of your home or commercial space", "Correction-first advice — fixes without demolition or breaking walls", "Identification of doshas (imbalances) and their effect on you", "Direction guidance for beds, kitchen, workspace and entrance"],
          bring: ["A floor plan or rough sketch of your home/office", "The facing direction of the main entrance", "Photos of key rooms (optional)"],
        },
        {
          name: "Numerology", tag: "Numbers", desc: "Decoding the numbers of your name and birth to reveal your natural rhythm.",
          long: "Every name and birth date carries a vibration. Numerology decodes these numbers to reveal your life path, personality and the cycles you are moving through — and where a small spelling change or a chosen number can bring things back into flow.",
          duration: "45–60 minutes",
          expect: ["Your life-path, destiny and name numbers explained simply", "Your personal year cycle and what it favours", "Lucky numbers, days and colours tuned to you", "Name-correction suggestions if they will genuinely help"],
          bring: ["Your full name as commonly used", "Your date of birth", "Any name spellings you are considering"],
        },
        {
          name: "Karma Alignment", tag: "Life Path", desc: "Understanding past patterns so you can consciously shape a lighter future.",
          long: "Some struggles repeat until we understand them. Karma alignment looks at the recurring patterns in your chart and life, helping you see their root with compassion — so you can release old cycles and move forward more lightly.",
          duration: "60 minutes",
          expect: ["Insight into repeating patterns and their karmic root", "A compassionate, judgement-free conversation", "Practices to release and rebalance heavy patterns", "A clear intention to carry forward"],
          bring: ["Your birth details (date, time, place)", "An open, honest frame of mind", "Any specific pattern you want to understand"],
        },
        {
          name: "Mobile Numerology", tag: "Numbers", desc: "Tuning the numbers you use daily — phone, vehicle — to support your goals.",
          long: "The numbers you carry every day — your phone, your vehicle — hold a vibration that quietly interacts with your own. Mobile numerology analyses these and suggests small, sensible tweaks so your daily numbers work with you, not against you.",
          duration: "30–45 minutes",
          expect: ["Analysis of your current phone / vehicle numbers", "How well they harmonise with your birth numbers", "Suggested number combinations for a new SIM or plate", "Quick, low-effort adjustments you can make today"],
          bring: ["Your current mobile number", "Your date of birth", "Your specific goal (career, calm, growth)"],
        },
        {
          name: "Yantra & Mantra", tag: "Sacred Tools", desc: "Prescribing time-tested yantras and mantras as gentle protective supports.",
          long: "Yantras are sacred geometric diagrams and mantras are sound formulas — both refined over centuries as gentle, protective supports. Nakshtra Vidhya prescribes the ones suited to your chart and need, with clear guidance on how to keep and use them.",
          duration: "45 minutes",
          expect: ["The right yantra and mantra chosen for your chart", "Clear instructions on placement, care and timing", "How and how often to chant, in simple steps", "A protective daily practice you can sustain"],
          bring: ["Your birth details", "The concern you want support with", "A quiet, sincere intention"],
        },
        {
          name: "Runes", tag: "Divination", desc: "Ancient rune casting for quick, honest insight into a pressing question.",
          long: "Runes are an ancient system of symbols cast to reflect the energy around a question. When you need a quick, honest nudge on a specific decision, a rune reading offers clear, grounded perspective — never fatalistic, always empowering.",
          duration: "30 minutes",
          expect: ["A focused reading on one clear question", "Honest, grounded perspective — not doom", "Practical guidance on the next step", "Space to ask a follow-up question"],
          bring: ["One clear question you'd like guidance on", "An open mind", "A few quiet minutes to focus"],
        },
        {
          name: "Healing", tag: "Energy Work", desc: "Chakra and energy balancing to release what weighs on body and mind.",
          long: "When stress settles into the body, energy healing helps release it. Nakshtra Vidhya works gently with your chakras and energy field to clear stagnation and restore calm — a soothing reset for body and mind.",
          duration: "45–60 minutes",
          expect: ["A calming assessment of your energy centres", "Gentle clearing of stagnant, heavy energy", "Deep relaxation and a lighter, clearer feeling", "Simple self-care to hold the balance at home"],
          bring: ["Comfortable, loose clothing", "A light stomach — a small snack beforehand is fine", "Willingness to relax fully"],
        },
        {
          name: "Crystal", tag: "Stones", desc: "Choosing crystals that match your energy for calm, focus and protection.",
          long: "Crystals carry steady, natural vibrations that can support calm, focus and protection. Nakshtra Vidhya helps you choose the stones that match your energy and intention, and shows you how to cleanse, charge and carry them.",
          duration: "30–45 minutes",
          expect: ["Crystals matched to your energy and intention", "What each stone supports — calm, focus, protection", "How to cleanse and charge your crystals", "Simple ways to wear or place them daily"],
          bring: ["Your main intention (calm, focus, love, protection)", "Your date of birth", "Any crystals you already own (optional)"],
        },
        {
          name: "Raashi Ratn", tag: "Gemstones", desc: "Recommending the right gemstone for your zodiac to strengthen weak planets.",
          long: "The right gemstone, worn correctly, can strengthen a weak but well-placed planet in your chart. Nakshtra Vidhya studies your chart carefully before recommending any stone — including the metal, finger and day — so you invest wisely and never blindly.",
          duration: "45 minutes",
          expect: ["A chart-based recommendation — never one-size-fits-all", "The right gemstone, weight, metal and finger", "The auspicious day and method to wear it", "Honest advice, including when NOT to wear a stone"],
          bring: ["Your birth details (date, time, place)", "Details of any gemstones you already wear", "Your key concern or goal"],
        },
        {
          name: "Mojo Bag", tag: "Charms", desc: "A personal pouch of intention — herbs and stones set for a specific need.",
          long: "A mojo bag is a small, personal pouch charged with a specific intention — carrying herbs, stones and symbols chosen for your need, whether protection, prosperity or peace. Nakshtra Vidhya prepares yours mindfully and explains how to keep it alive.",
          duration: "30 minutes",
          expect: ["A pouch prepared for your specific intention", "Herbs, stones and symbols chosen for you", "Guidance on how to carry and refresh it", "A grounding ritual to activate it"],
          bring: ["Your clear intention (protection, prosperity, peace)", "Your date of birth", "A small personal token (optional)"],
        },
        {
          name: "Zibu Symbol", tag: "Symbols", desc: "Angelic Zibu symbols drawn to invite healing, love and gentle protection.",
          long: "Zibu symbols are flowing, angelic marks — each one carrying a specific blessing such as healing, love or protection. Nakshtra Vidhya helps you choose and draw the symbols that speak to your need, and shows you how to use them in daily life.",
          duration: "30 minutes",
          expect: ["The Zibu symbols suited to your need", "The meaning and blessing each one carries", "How to draw and place them", "Simple daily ways to work with them"],
          bring: ["Your intention (healing, love, protection, calm)", "A journal or paper (optional)", "An open heart"],
        },
        {
          name: "Logo Design", tag: "Brand Energy", desc: "Numerology & vastu-aligned logos that quietly attract growth and goodwill.",
          long: "A logo carries the vibration of your brand. Nakshtra Vidhya designs and refines logos in line with numerology and vastu principles — balancing colour, form and direction so your mark quietly attracts growth, trust and goodwill.",
          duration: "3–5 days",
          expect: ["A numerology and vastu review of your brand name", "Colour, shape and direction chosen to support growth", "2–3 logo concepts refined to your feedback", "Final files ready for print and digital use"],
          bring: ["Your brand or business name", "Your date of birth / founding date", "Any colours or ideas you already like"],
        },
        {
          name: "Card Design", tag: "Numerology Cards", desc: "Visiting cards tuned to numerology so every card you hand out supports you.",
          long: "Your visiting card is a small object you hand out hundreds of times — so its numbers, layout and colours matter. Nakshtra Vidhya designs business cards tuned to numerology and vastu, so every card you give carries a supportive, prosperous energy.",
          duration: "2–4 days",
          expect: ["A number-balanced layout for your card", "Auspicious colours and fonts for your work", "Print-ready design in the size you need", "Guidance on the lucky details to include"],
          bring: ["Your name and business details", "Your date of birth", "Your logo, if you already have one"],
        },
        {
          name: "Signature Analysis", tag: "Handwriting", desc: "Reading and refining your signature to invite confidence and success.",
          long: "Your signature is a snapshot of how you present yourself to the world. Nakshtra Vidhya reads its lines and rhythm to reveal hidden patterns — then, where it genuinely helps, suggests small, sensible corrections to invite confidence, stability and success.",
          duration: "30–45 minutes",
          expect: ["An honest reading of your current signature", "What its strokes reveal about your patterns", "A corrected signature, if it will truly help", "Practice guidance to make the new one natural"],
          bring: ["A few samples of your current signature", "Your date of birth", "A pen you write with comfortably"],
        },
      ],
    },
    serviceDetail: {
      overline: "Consultation",
      expect: "What to expect",
      bring: "What to bring",
      duration: "Typical duration",
      cta: "Book this consultation",
      ask: "Ask on WhatsApp",
      back: "All services",
      next: "Next service",
      prev: "Previous service",
      note: "Every consultation is private, unhurried and free of fear-mongering.",
    },
    contact: {
      overline: "Begin the Conversation",
      title: "Let's find your\nclarity together.",
      body: "For authentic guidance grounded in vedic wisdom, reach out by phone or WhatsApp. Every enquiry is handled personally and in complete confidence.",
      callLabel: "Call",
      whatsappLabel: "Message on WhatsApp",
      hoursLabel: "Consultation Hours",
      hours: "Mon – Sat · 10:00 am – 7:00 pm",
    },
    footer: {
      tagline: "Ancient vedic sciences, offered with care.",
      rights: "All rights reserved.",
    },
  },

  hi: {
    dir: "hi",
    brand: "नक्षत्र विद्या",
    nav: {
      about: "परिचय",
      philosophy: "दर्शन",
      services: "सेवाएँ",
      contact: "संपर्क",
      call: "कॉल करें",
    },
    hero: {
      overline: "वास्तु · ज्योतिष · प्राचीन वैदिक विज्ञान",
      titleLines: ["प्राचीन वैदिक", "ज्ञान से जुड़ा", "मार्गदर्शन।"],
      subtitle:
        "नक्षत्र विद्या आपके घर, आपके ग्रहों और आपके अंकों के शांत संकेतों को पढ़ने में आपकी मदद करता है — ताकि आप जीवन में भय के साथ नहीं, स्पष्टता के साथ आगे बढ़ें।",
      ctaPrimary: "सेवाएँ देखें",
      ctaSecondary: "व्हाट्सएप पर बात करें",
      badge: "15+ वर्षों का अनुभव",
    },
    marquee: ["वास्तु", "ज्योतिष", "अंक ज्योतिष", "हीलिंग", "यंत्र", "मंत्र", "क्रिस्टल", "कर्म"],
    philosophy: {
      overline: "दर्शन",
      title: "चेतावनी और रक्षा के लिए —\nभयभीत करने के लिए नहीं।",
      chapters: [
        { no: "०१", title: "एक प्राचीन विज्ञान, अंधविश्वास नहीं", body: "वास्तु और ज्योतिष भारत के सबसे प्राचीन प्रेक्षण-आधारित विज्ञानों में से हैं — हज़ारों वर्षों में परिष्कृत, यह समझने के लिए कि स्थान, समय और ऊर्जा हमारे जीवन को कैसे आकार देते हैं।" },
        { no: "०२", title: "समय रहते एक कोमल चेतावनी", body: "उद्देश्य कभी भय फैलाना नहीं है। यह आपको एक स्नेहपूर्ण, समय पर संकेत देना है — ताकि आज के छोटे सुधार आने वाले वर्षों की रक्षा कर सकें।" },
        { no: "०३", title: "ऐसी स्पष्टता जिस पर आप अमल कर सकें", body: "हर परामर्श सरल, व्यावहारिक उपायों के साथ पूरा होता है — एक दिशा बदलना, एक मंत्र अपनाना, एक रत्न धारण करना — ज़मीनी, सच्चे और आसानी से अपनाए जा सकने वाले।" },
      ],
    },
    about: {
      overline: "नक्षत्र विद्या के बारे में",
      title: "छिपे हुए को उजागर करने के\nपंद्रह वर्ष।",
      body: [
        "15 से अधिक वर्षों से, नक्षत्र विद्या परिवारों और व्यक्तियों को वास्तु, ज्योतिष और संबंधित वैदिक विद्याओं के माध्यम से मार्गदर्शन देता आ रहा है।",
        "यहाँ का दृष्टिकोण शांत, व्यक्तिगत और भय-मुक्त है — आपकी कुंडली, आपके घर और आपके अंकों को पढ़कर उन्हें ऐसे उपायों में बदला जाता है जिन्हें आप सहजता से अपना सकें।",
        "लोग यहाँ विनाश की भविष्यवाणी के लिए नहीं, बल्कि आश्वासन, दिशा और अपने प्रियजनों की रक्षा की भावना के लिए आते हैं।",
      ],
      stats: [
        { value: "15+", label: "वर्षों का अनुभव" },
        { value: "15", label: "वैदिक विद्याएँ" },
        { value: "हज़ारों", label: "परामर्श दिए" },
      ],
    },
    services: {
      overline: "नक्षत्र विद्या की सेवाएँ",
      title: "वैदिक मार्गदर्शन के\nपंद्रह मार्ग।",
      subtitle: "हर सेवा एक द्वार है — वही चुनें जो इस समय आपके मन की बात कहे।",
      cardCta: "और जानें",
      helpTitle: "कहाँ से शुरू करें, तय नहीं?",
      helpCta: "व्हाट्सएप पर पूछें",
      items: [
        {
          name: "ज्योतिष", tag: "वैदिक ज्योतिष", desc: "समय, शक्तियों और आगे के मार्ग को समझने के लिए आपकी जन्म कुंडली का अध्ययन।",
          highlights: ["किसी भी भाषा में कुंडली", "पूरे भारत में निःशुल्क डिलीवरी", "गहन कुंडली विश्लेषण"],
          long: "ज्योतिष अर्थात् 'प्रकाश का विज्ञान' आपके जन्म के समय ग्रहों की स्थिति का अध्ययन करता है, ताकि आपकी स्वाभाविक शक्तियाँ, कर्म के सबक और जीवन की महत्वपूर्ण घटनाओं का समय उजागर हो सके। यहाँ आपकी कुंडली आपकी पसंद की किसी भी भाषा में तैयार की जाती है — पूरे भारत में निःशुल्क डिलीवरी के साथ — और उसे स्नेह के साथ पढ़ा जाता है, अवसरों को उभारते हुए तथा जिन समयों में सावधानी चाहिए उनकी कोमल चेतावनी देते हुए।",
          duration: "60–90 मिनट",
          expect: ["आपकी पसंद की भाषा में हाथ से तैयार की गई कुंडली", "पूरे भारत में निःशुल्क डिलीवरी", "भाव-दर-भाव गहन कुंडली विश्लेषण", "करियर, रिश्ते, स्वास्थ्य और धन पर सच्ची अंतर्दृष्टि", "कमज़ोर क्षेत्रों को बल देने के सरल, व्यावहारिक उपाय"],
          bring: ["आपकी सही जन्म तिथि", "आपका सटीक जन्म समय", "आपका जन्म स्थान (शहर)"],
        },
        {
          name: "वास्तु", tag: "स्थान संतुलन", desc: "संतुलन और उन्नति के लिए आपके घर व कार्यस्थल को प्राकृतिक ऊर्जा से जोड़ना।",
          highlights: ["बिना तोड़-फोड़ के सुधार", "घर और व्यावसायिक स्थान"],
          long: "वास्तु शास्त्र आपके रहने और कार्य करने के स्थानों को पंचतत्वों और प्राकृतिक ऊर्जा के प्रवाह से जोड़ता है। घर और व्यावसायिक स्थान — दोनों के लिए यहाँ यह पहचाना जाता है कि किसी स्थान की ऊर्जा कहाँ आपका साथ देती है और कहाँ चुपचाप आपको थकाती है — फिर ऐसे व्यावहारिक सुधार सुझाए जाते हैं जिनमें प्रायः तोड़-फोड़ या दीवारें तोड़ने की ज़रूरत नहीं होती।",
          duration: "60–90 मिनट",
          expect: ["आपके घर या व्यावसायिक स्थान का कमरे-दर-कमरे विश्लेषण", "सुधार-पहले सलाह — बिना तोड़-फोड़, बिना दीवार तोड़े", "दोषों (असंतुलन) और उनके प्रभाव की पहचान", "बिस्तर, रसोई, कार्यस्थल और प्रवेश हेतु दिशा मार्गदर्शन"],
          bring: ["आपके घर/कार्यालय का नक्शा या मोटा रेखाचित्र", "मुख्य द्वार की दिशा", "मुख्य कमरों की तस्वीरें (वैकल्पिक)"],
        },
        {
          name: "अंक ज्योतिष", tag: "अंक", desc: "आपके नाम और जन्म के अंकों को समझकर आपकी स्वाभाविक लय को उजागर करना।",
          long: "हर नाम और जन्म तिथि एक कंपन धारण करती है। अंक ज्योतिष इन अंकों को समझकर आपके जीवन-पथ, स्वभाव और चल रहे चक्रों को उजागर करता है — और बताता है कि कहाँ नाम की छोटी वर्तनी या एक चुना हुआ अंक चीज़ों को फिर से प्रवाह में ला सकता है।",
          duration: "45–60 मिनट",
          expect: ["आपके जीवन-पथ, भाग्य और नाम अंक सरलता से समझाए गए", "आपका व्यक्तिगत वर्ष चक्र और उसका शुभ पक्ष", "आपके अनुकूल शुभ अंक, दिन और रंग", "यदि सच में सहायक हो तो नाम-सुधार सुझाव"],
          bring: ["आपका प्रचलित पूरा नाम", "आपकी जन्म तिथि", "जो नाम-वर्तनी आप सोच रहे हैं (यदि कोई)"],
        },
        {
          name: "कर्म संरेखण", tag: "जीवन पथ", desc: "पुराने प्रतिरूपों को समझना ताकि आप सचेत रूप से हल्का भविष्य रच सकें।",
          long: "कुछ कठिनाइयाँ तब तक दोहराती हैं जब तक हम उन्हें समझ नहीं लेते। कर्म संरेखण आपकी कुंडली और जीवन में बार-बार आने वाले प्रतिरूपों को देखता है और करुणा के साथ उनकी जड़ तक पहुँचने में मदद करता है — ताकि आप पुराने चक्रों को छोड़ हल्के मन से आगे बढ़ सकें।",
          duration: "60 मिनट",
          expect: ["दोहराते प्रतिरूपों और उनकी कर्म-जड़ की अंतर्दृष्टि", "करुणामय, बिना निर्णय की बातचीत", "भारी प्रतिरूपों को छोड़ने और संतुलित करने की क्रियाएँ", "आगे ले जाने योग्य एक स्पष्ट संकल्प"],
          bring: ["आपकी जन्म जानकारी (तिथि, समय, स्थान)", "खुला और सच्चा मन", "जो विशेष प्रतिरूप आप समझना चाहते हैं"],
        },
        {
          name: "मोबाइल अंक ज्योतिष", tag: "अंक", desc: "आपके दैनिक अंकों — फ़ोन, वाहन — को आपके लक्ष्यों के अनुकूल बनाना।",
          long: "जो अंक आप हर दिन साथ रखते हैं — आपका फ़ोन, आपका वाहन — एक कंपन धारण करते हैं जो चुपचाप आपकी अपनी ऊर्जा पर प्रभाव डालता है। मोबाइल अंक ज्योतिष इनका विश्लेषण करता है और छोटे, समझदार बदलाव सुझाता है ताकि आपके दैनिक अंक आपके विरुद्ध नहीं, आपके साथ काम करें।",
          duration: "30–45 मिनट",
          expect: ["आपके वर्तमान फ़ोन / वाहन अंकों का विश्लेषण", "वे आपके जन्म अंकों से कितने मेल खाते हैं", "नए सिम या नंबर प्लेट हेतु अंक संयोजन सुझाव", "आज ही किए जा सकने वाले सरल बदलाव"],
          bring: ["आपका वर्तमान मोबाइल नंबर", "आपकी जन्म तिथि", "आपका विशेष लक्ष्य (करियर, शांति, उन्नति)"],
        },
        {
          name: "यंत्र और मंत्र", tag: "पवित्र साधन", desc: "कोमल रक्षा हेतु समय-परखे यंत्र और मंत्र का निर्धारण।",
          long: "यंत्र पवित्र ज्यामितीय आकृतियाँ हैं और मंत्र ध्वनि-सूत्र — दोनों सदियों में परिष्कृत कोमल, रक्षात्मक सहारे। आपकी कुंडली और ज़रूरत के अनुसार उपयुक्त यंत्र-मंत्र निर्धारित किए जाते हैं, साथ ही उन्हें रखने और प्रयोग करने का स्पष्ट मार्गदर्शन दिया जाता है।",
          duration: "45 मिनट",
          expect: ["आपकी कुंडली हेतु सही यंत्र और मंत्र का चयन", "स्थापना, देखभाल और समय पर स्पष्ट निर्देश", "जप कैसे और कितनी बार करें, सरल चरणों में", "जिसे आप निभा सकें ऐसी दैनिक रक्षात्मक साधना"],
          bring: ["आपकी जन्म जानकारी", "जिस विषय में सहारा चाहिए", "एक शांत, सच्चा संकल्प"],
        },
        {
          name: "रून्स", tag: "शकुन विद्या", desc: "किसी ज़रूरी प्रश्न पर त्वरित, सच्ची अंतर्दृष्टि के लिए प्राचीन रून विद्या।",
          long: "रून प्रतीकों की एक प्राचीन प्रणाली है, जिन्हें किसी प्रश्न के आसपास की ऊर्जा को प्रतिबिंबित करने के लिए बिछाया जाता है। जब आपको किसी विशेष निर्णय पर त्वरित, सच्चा संकेत चाहिए, तब रून पठन एक स्पष्ट, स्थिर दृष्टिकोण देता है — कभी भाग्यवादी नहीं, सदा सशक्त बनाने वाला।",
          duration: "30 मिनट",
          expect: ["एक स्पष्ट प्रश्न पर केंद्रित पठन", "सच्चा, स्थिर दृष्टिकोण — भय नहीं", "अगले कदम पर व्यावहारिक मार्गदर्शन", "एक अतिरिक्त प्रश्न पूछने का अवसर"],
          bring: ["एक स्पष्ट प्रश्न जिस पर मार्गदर्शन चाहिए", "खुला मन", "ध्यान देने के लिए कुछ शांत क्षण"],
        },
        {
          name: "हीलिंग", tag: "ऊर्जा कार्य", desc: "तन-मन के बोझ को हल्का करने के लिए चक्र और ऊर्जा संतुलन।",
          long: "जब तनाव शरीर में बस जाता है, तब ऊर्जा हीलिंग उसे मुक्त करने में मदद करती है। कोमलता से आपके चक्रों और ऊर्जा-क्षेत्र पर कार्य किया जाता है ताकि ठहराव दूर हो और शांति लौटे — तन और मन के लिए एक सुकून भरा नवारंभ।",
          duration: "45–60 मिनट",
          expect: ["आपके ऊर्जा-केंद्रों का शांतिपूर्ण आकलन", "ठहरी हुई, भारी ऊर्जा की कोमल सफाई", "गहरी विश्रांति और हल्का, स्पष्ट अनुभव", "संतुलन बनाए रखने हेतु सरल स्व-देखभाल"],
          bring: ["आरामदायक, ढीले वस्त्र", "खाली पेट (पहले हल्का भोजन)", "पूरी तरह विश्राम करने की इच्छा"],
        },
        {
          name: "क्रिस्टल", tag: "रत्न पत्थर", desc: "शांति, एकाग्रता और रक्षा के लिए आपकी ऊर्जा से मेल खाते क्रिस्टल का चयन।",
          long: "क्रिस्टल स्थिर, प्राकृतिक कंपन धारण करते हैं जो शांति, एकाग्रता और रक्षा में सहायक हो सकते हैं। ऐसे पत्थर चुनने में आपकी मदद की जाती है जो आपकी ऊर्जा और संकल्प से मेल खाएँ, और उन्हें शुद्ध व ऊर्जित करना तथा साथ रखना समझाया जाता है।",
          duration: "30–45 मिनट",
          expect: ["आपकी ऊर्जा और संकल्प से मेल खाते क्रिस्टल", "हर पत्थर किसमें सहायक है — शांति, एकाग्रता, रक्षा", "अपने क्रिस्टल को शुद्ध व ऊर्जित कैसे करें", "इन्हें प्रतिदिन धारण या स्थापित करने के सरल तरीके"],
          bring: ["आपका मुख्य संकल्प (शांति, एकाग्रता, प्रेम, रक्षा)", "आपकी जन्म तिथि", "आपके पास पहले से मौजूद क्रिस्टल (वैकल्पिक)"],
        },
        {
          name: "राशि रत्न", tag: "रत्न", desc: "कमज़ोर ग्रहों को बल देने के लिए आपकी राशि हेतु सही रत्न की अनुशंसा।",
          long: "सही रत्न, सही ढंग से धारण किया जाए तो कुंडली में कमज़ोर परंतु शुभ स्थित ग्रह को बल दे सकता है। किसी भी रत्न की अनुशंसा से पहले आपकी कुंडली का ध्यानपूर्वक अध्ययन किया जाता है — धातु, उँगली और दिन सहित — ताकि आप समझदारी से निवेश करें, आँख मूँदकर नहीं।",
          duration: "45 मिनट",
          expect: ["कुंडली-आधारित अनुशंसा — सबके लिए एक जैसी नहीं", "सही रत्न, वज़न, धातु और उँगली", "धारण करने का शुभ दिन और विधि", "सच्ची सलाह, यह भी कि कब रत्न न पहनें"],
          bring: ["आपकी जन्म जानकारी (तिथि, समय, स्थान)", "आप पहले से जो रत्न पहनते हैं उनका विवरण", "आपकी मुख्य चिंता या लक्ष्य"],
        },
        {
          name: "मोजो बैग", tag: "ताबीज़", desc: "संकल्प की एक निजी पोटली — किसी विशेष उद्देश्य हेतु जड़ी-बूटियाँ व पत्थर।",
          long: "मोजो बैग एक छोटी, निजी पोटली है जो किसी विशेष संकल्प से चार्ज की जाती है — इसमें आपकी ज़रूरत के अनुसार चुनी गई जड़ी-बूटियाँ, पत्थर और प्रतीक होते हैं, चाहे रक्षा हो, समृद्धि या शांति। इसे ध्यानपूर्वक तैयार किया जाता है और इसे सजीव रखना समझाया जाता है।",
          duration: "30 मिनट",
          expect: ["आपके विशेष संकल्प हेतु तैयार पोटली", "आपके लिए चुनी गई जड़ी-बूटियाँ, पत्थर और प्रतीक", "इसे साथ रखने और नवीकृत करने का मार्गदर्शन", "इसे सक्रिय करने की एक स्थिर करने वाली विधि"],
          bring: ["आपका स्पष्ट संकल्प (रक्षा, समृद्धि, शांति)", "आपकी जन्म तिथि", "एक छोटी निजी वस्तु (वैकल्पिक)"],
        },
        {
          name: "ज़िबू प्रतीक", tag: "प्रतीक", desc: "उपचार, प्रेम और कोमल रक्षा को आमंत्रित करने वाले दिव्य ज़िबू प्रतीक।",
          long: "ज़िबू प्रतीक बहते हुए, दिव्य चिह्न हैं — प्रत्येक एक विशेष आशीर्वाद धारण करता है जैसे उपचार, प्रेम या रक्षा। वे प्रतीक चुनने और बनाने में आपकी मदद की जाती है जो आपकी ज़रूरत से मेल खाएँ, और उन्हें दैनिक जीवन में प्रयोग करना समझाया जाता है।",
          duration: "30 मिनट",
          expect: ["आपकी ज़रूरत के अनुकूल ज़िबू प्रतीक", "प्रत्येक का अर्थ और उसका आशीर्वाद", "इन्हें कैसे बनाएँ और कहाँ रखें", "इनके साथ कार्य करने के सरल दैनिक तरीके"],
          bring: ["आपका संकल्प (उपचार, प्रेम, रक्षा, शांति)", "एक डायरी या कागज़ (वैकल्पिक)", "एक खुला हृदय"],
        },
        {
          name: "लोगो डिज़ाइन", tag: "ब्रांड ऊर्जा", desc: "अंक ज्योतिष व वास्तु के अनुरूप लोगो जो चुपचाप उन्नति और सद्भाव आकर्षित करें।",
          long: "एक लोगो आपके ब्रांड का कंपन धारण करता है। अंक ज्योतिष और वास्तु सिद्धांतों के अनुरूप लोगो डिज़ाइन व परिष्कृत किया जाता है — रंग, आकार और दिशा को संतुलित कर, ताकि आपका प्रतीक चुपचाप उन्नति, विश्वास और सद्भाव आकर्षित करे।",
          duration: "3–5 दिन",
          expect: ["आपके ब्रांड नाम की अंक व वास्तु समीक्षा", "उन्नति हेतु चुने गए रंग, आकार और दिशा", "आपकी प्रतिक्रिया अनुसार परिष्कृत 2–3 लोगो अवधारणाएँ", "प्रिंट व डिजिटल उपयोग हेतु तैयार अंतिम फ़ाइलें"],
          bring: ["आपका ब्रांड या व्यवसाय नाम", "आपकी जन्म तिथि / स्थापना तिथि", "जो रंग या विचार आपको पहले से पसंद हों"],
        },
        {
          name: "कार्ड डिज़ाइन", tag: "व्यवसाय कार्ड", desc: "अंक ज्योतिष के अनुरूप विज़िटिंग कार्ड, ताकि आपका हर कार्ड आपका साथ दे।",
          long: "आपका विज़िटिंग कार्ड एक छोटी वस्तु है जिसे आप सैकड़ों बार देते हैं — इसलिए उसके अंक, ले-आउट और रंग मायने रखते हैं। अंक ज्योतिष व वास्तु के अनुरूप बिज़नेस कार्ड डिज़ाइन किए जाते हैं, ताकि आपका हर कार्ड एक सहायक, समृद्ध ऊर्जा साथ ले जाए।",
          duration: "2–4 दिन",
          expect: ["आपके कार्ड हेतु अंक-संतुलित ले-आउट", "आपके कार्य हेतु शुभ रंग और फ़ॉन्ट", "आपकी ज़रूरत के आकार में प्रिंट-तैयार डिज़ाइन", "शामिल करने योग्य शुभ विवरण पर मार्गदर्शन"],
          bring: ["आपका नाम और व्यवसाय विवरण", "आपकी जन्म तिथि", "आपका लोगो, यदि पहले से हो"],
        },
        {
          name: "हस्ताक्षर विश्लेषण", tag: "लिखावट", desc: "आत्मविश्वास और सफलता हेतु आपके हस्ताक्षर का विश्लेषण व सुधार।",
          long: "आपका हस्ताक्षर इस बात की झलक है कि आप स्वयं को दुनिया के सामने कैसे प्रस्तुत करते हैं। इसकी रेखाओं और लय को पढ़कर छिपे प्रतिरूप उजागर किए जाते हैं — फिर, जहाँ सच में सहायक हो, आत्मविश्वास, स्थिरता और सफलता को आमंत्रित करने हेतु छोटे, समझदार सुधार सुझाए जाते हैं।",
          duration: "30–45 मिनट",
          expect: ["आपके वर्तमान हस्ताक्षर का सच्चा विश्लेषण", "इसकी रेखाएँ आपके प्रतिरूपों के बारे में क्या कहती हैं", "यदि सच में सहायक हो तो एक सुधारा हुआ हस्ताक्षर", "नए हस्ताक्षर को सहज बनाने हेतु अभ्यास मार्गदर्शन"],
          bring: ["आपके वर्तमान हस्ताक्षर के कुछ नमूने", "आपकी जन्म तिथि", "एक कलम जिससे आप सहजता से लिखें"],
        },
      ],
    },
    serviceDetail: {
      overline: "परामर्श",
      expect: "क्या अपेक्षा करें",
      bring: "क्या साथ लाएँ",
      duration: "सामान्य अवधि",
      cta: "यह परामर्श बुक करें",
      ask: "व्हाट्सएप पर पूछें",
      back: "सभी सेवाएँ",
      next: "अगली सेवा",
      prev: "पिछली सेवा",
      note: "हर परामर्श निजी, इत्मीनान भरा और भय-मुक्त होता है।",
    },
    contact: {
      overline: "बातचीत शुरू करें",
      title: "आइए मिलकर आपकी\nस्पष्टता खोजें।",
      body: "वैदिक ज्ञान पर आधारित प्रामाणिक मार्गदर्शन हेतु फ़ोन या व्हाट्सएप पर संपर्क करें। प्रत्येक जिज्ञासा पर व्यक्तिगत रूप से और पूर्ण गोपनीयता के साथ विचार किया जाता है।",
      callLabel: "कॉल",
      whatsappLabel: "व्हाट्सएप पर संदेश",
      hoursLabel: "परामर्श समय",
      hours: "सोम – शनि · सुबह 10:00 – शाम 7:00",
    },
    footer: {
      tagline: "प्राचीन वैदिक विज्ञान, स्नेह के साथ।",
      rights: "सर्वाधिकार सुरक्षित।",
    },
  },
  hinglish,
};
